<template>
  <div class="as-wrapper">
    <div class="as">
      <div class="as-filter">
        <div class="as-filter-left">
          <el-button type="primary" size="small" round @click="onOperate">
            新建内容
          </el-button>

          <!-- <el-button  :type="showCaogao?'primary':''"
            size="small"
            round  @click.stop="onOperCaogao(true)">资讯列表</el-button>
          <el-button  :type="!showCaogao?'primary':''"
            size="small"
            round  @click.stop="onOperCaogao(false)">草稿箱</el-button> -->
          <div
            style="
              display: flex;
              font-size: 14px;
              line-height: 32px;
              color: #333333;
              cursor: pointer;
              margin-left: 30px;
            "
          >
            <div
              :style="{
                'border-bottom': showCaogao ? '2px solid #0E6CCB' : 'none',
                color: showCaogao ? '#0E6CCB' : '#333333',
              }"
              @click.stop="onOperCaogao(true)"
            >
              资讯列表
            </div>
            <div
              style="margin-left: 25px;"
              @click.stop="onOperCaogao(false)"
              :style="{
                'border-bottom': !showCaogao ? '2px solid #0E6CCB' : 'none',
                color: !showCaogao ? '#0E6CCB' : '#333333',
              }"
            >
              草稿箱
            </div>
          </div>
        </div>
        <div class="as-filter-right" v-if="showCaogao">
          <el-date-picker
            style="width: 215px;"
            v-model="date_start"
            type="datetime"
            placeholder="请选择开始日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change="
              () => {
                pageNo = 1
                asyncData()
              }
            "
            size="small"
          ></el-date-picker>
          <span
            style="width: 5px; margin-top: 15px; margin-left: 5px;"
            class="et-line"
          ></span>
          <el-date-picker
            style="width: 215px;"
            v-model="date_end"
            type="datetime"
            placeholder="请选择结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change="
              () => {
                pageNo = 1
                asyncData()
              }
            "
            size="small"
          ></el-date-picker>
          <el-select
            v-model="status"
            placeholder="全部状态"
            size="small"
            clearable
            @change="
              () => {
                pageNo = 1
                asyncData()
              }
            "
          >
            <el-option
              v-for="(opt, index) in terminalOptions"
              :key="index"
              :label="opt.label"
              :value="opt.value"
            />
          </el-select>
          <el-input
            v-model.trim="keyword"
            placeholder="请输入标题"
            size="small"
            clearable
            @clear="
              () => {
                pageNo = 1
                asyncData()
              }
            "
            @keyup.enter.native="
              () => {
                pageNo = 1
                asyncData()
              }
            "
          >
            <i
              slot="suffix"
              class="el-input__icon el-icon-search"
              @click="
                () => {
                  pageNo = 1
                  asyncData()
                }
              "
            ></i>
          </el-input>
        </div>
      </div>
      <!-- <span style="flex:1">此列表不包含草稿状态的资讯，可在事务中心草稿箱查看该类资讯</span> -->
      <div class="as-total">共 {{ showCaogao ? total : total1 }} 条数据</div>
      <div v-if="showCaogao">
        <el-table
          :data="tableData"
          size="small"
          v-loading="loading"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0)"
        >
          <el-table-column
            type="index"
            :index="(pageNo - 1) * pageSize + 1"
            label="序号"
            width="65px"
          >
          </el-table-column>
          <el-table-column prop="title" label="标题名称">
            <template slot-scope="scope">
              <div class="keep-hue oneRowEllipsis">
                <img
                  src="@/assets/NewsCenter/topstatus.png"
                  alt=""
                  v-if="scope.row.topStatus == '1'"
                  width="22px"
                />{{ scope.row.title }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="columnName" label="所属栏目" width="80px">
          </el-table-column>
          <el-table-column
            prop="releaseDeptName"
            label="发布单位"
            width="110px"
          >
            <template slot-scope="scope">
              <div class="oneRowEllipsis">{{ scope.row.releaseDeptName }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="releaseUser" label="发布人" width="90px">
            <template slot-scope="scope">
              <div class="oneRowEllipsis">{{ scope.row.releaseUser }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="releaseStatus" label="审核状态" width="80px">
            <template slot-scope="scope">
              <span
                class="keep-hue"
                v-if="scope.row.releaseStatus == '1'"
                style="color: #22a498;"
              >
                通过
              </span>
              <span
                class="keep-hue"
                v-if="scope.row.releaseStatus == '2'"
                style="color: #e64d55;"
              >
                不通过
              </span>
              <span
                class="keep-hue"
                v-if="scope.row.releaseStatus == '0'"
                style="color: #ff7e35;"
              >
                审核中
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="reviewStatus" label="发布状态" width="80px">
            <template slot-scope="scope">
              <span
                class="keep-hue"
                v-if="scope.row.reviewStatus == '1'"
                style="color: #22a498;"
              >
                已发布
              </span>
              <span v-if="scope.row.reviewStatus == '0'" class="keep-hue">
                未发布
              </span>
              <span
                v-if="scope.row.reviewStatus == '2'"
                class="keep-hue"
                style="color: #ff7e35;"
              >
                已撤销
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="readCount" label="阅读数" width="70px">
            <template slot-scope="scope">
              <span v-if="scope.row.releaseStatus == '1'">{{
                scope.row.readCount
              }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>

          <el-table-column prop="createTime" label="创建时间" width="165px">
            <template slot-scope="scope">
              <div class="oneRowEllipsis">
                {{
                scope.row.createTime
                | formatDate('YYYY-MM-DD HH:mm', '-', 'utc')
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="releaseStartTime"
            label="发布时间"
            width="165px"
          >
            <template slot-scope="scope">
              <div>
                {{
                scope.row.releaseStartTime
                | formatDate('YYYY-MM-DD HH:mm', '-', 'utc')
                }}
              </div>
            </template>
          </el-table-column>

          <el-table-column
            prop="operation"
            label="操作"
            width="100px"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-tooltip placement="top" content="查看">
                <el-button
                  type="text"
                  icon="el-icon-document"
                  @click="onOperate2(scope.row.id)"
                />
                <!-- @click="onOperate1(scope.row.processInstanceId,scope.row.ffid)" -->
              </el-tooltip>
              <el-tooltip
                placement="top"
                content="重新发布"
                v-if="'2' == scope.row.reviewStatus"
              >
                <el-button
                  type="text"
                  icon="el-icon-s-promotion"
                  @click="onReviewStatus(scope.row)"
                />
              </el-tooltip>
              <el-tooltip
                v-if="'1' == scope.row.reviewStatus"
                placement="top"
                content="撤销发布"
              >
                <svg-icon
                  @click="cancelPublishNews(scope.row)"
                  style="width: 16px; height: 16px; margin-left: 5px;"
                  icon="su-icon-offline"
                ></svg-icon>
                <!-- @click="onOperate1(scope.row.processInstanceId,scope.row.ffid)" -->
              </el-tooltip>
              <el-tooltip
                placement="top"
                content="置顶"
                v-if="
                  scope.row.topStatus == '0' &&
                  scope.row.releaseStatus == '1' &&
                  columnAdminData.indexOf(scope.row.columnId) !== -1
                "
              >
                <img
                  @click.stop="changeTopData(scope.row.id, true)"
                  src="@/assets/su-icon-up.svg"
                  alt=""
                  style="width: 18px; height: 18px; margin-left: 5px;"
                />

                <!-- <sw-icon
                icon="upload"
                style="color:#0e6ccb;width: 16px;height: 16px;margin-left: 5px;"
              /> -->
              </el-tooltip>
              <el-tooltip
                placement="top"
                content="取消置顶"
                v-if="
                  scope.row.topStatus == '1' &&
                  scope.row.releaseStatus == '1' &&
                  columnAdminData.indexOf(scope.row.columnId) !== -1
                "
              >
                <img
                  @click.stop="changeTopData(scope.row.id, false)"
                  src="@/assets/su-icon-quxiaoup.svg"
                  alt=""
                  style="width: 18px; height: 18px; margin-left: 5px;"
                />

                <!-- <sw-icon
                icon="upload"
                style="color:#0e6ccb;width: 16px;height: 16px;margin-left: 5px;"
              /> -->
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <template v-if="total > pageSize">
          <div class="as-pagination">
            <el-pagination
              layout="prev, pager, next, jumper"
              :total="total"
              :current-page.sync="pageNo"
              :page-size.sync="pageSize"
              background
              @current-change="asyncData"
            />
          </div>
        </template>
      </div>
      <div v-if="!showCaogao">
        <el-table
          :data="tableData1"
          size="small"
          v-loading="loading1"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0)"
        >
          <el-table-column
            type="index"
            :index="(pageNo1 - 1) * pageSize + 1"
            label="序号"
            width="65px"
          >
          </el-table-column>
          <el-table-column prop="title" label="标题名称">
            <template slot-scope="scope">
              <div>{{ scope.row.title || scope.row.redTitle || '-' }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="catalogName" label="所属栏目" width="80px">
          </el-table-column>
          <el-table-column
            prop="releaseDeptName"
            label="发布单位"
            width="110px"
          >
            <template slot-scope="scope">
              <div class="oneRowEllipsis">{{ scope.row.releaseDeptName }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="releaseUser" label="发布人" width="90px">
            <template slot-scope="scope">
              <div class="oneRowEllipsis">{{ scope.row.releaseUser }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="165px">
            <template slot-scope="scope">
              <div class="oneRowEllipsis">{{ scope.row.createTime }}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="operation"
            label="操作"
            width="100px"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-tooltip placement="top" content="查看">
                <el-button
                  type="text"
                  icon="el-icon-document"
                  @click="onOperateCaogao(scope.row)"
                />
                <!-- @click="onOperate1(scope.row.processInstanceId,scope.row.ffid)" -->
              </el-tooltip>
              <el-tooltip placement="top" content="删除">
                <el-button
                  type="text"
                  icon="el-icon-delete"
                  @click="onDeleteCaogao(scope.row.id)"
                />
                <!-- @click="onOperate1(scope.row.processInstanceId,scope.row.ffid)" -->
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <template v-if="total1 > pageSize">
          <div class="as-pagination">
            <el-pagination
              layout="prev, pager, next, jumper"
              :total="total1"
              :current-page.sync="pageNo1"
              :page-size.sync="pageSize"
              background
              @current-change="asyncData"
            />
          </div>
        </template>
      </div>
    </div>
    <el-dialog
      title="选择栏目"
      :visible.sync="dialogFormVisible"
      :append-to-body="true"
    >
      <el-form :model="form" :rules="rules">
        <el-form-item label="所属栏目" prop="columnName">
          <el-select v-model="form.columnValue" placeholder="请选择所属栏目">
            <el-option
              v-for="item in columnData"
              :key="item.id"
              :label="item.columnName"
              :value="item.id + '&' + item.flowId + '&' + item.columnName"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <div v-if="showIndex">
          <p>1.资讯发布过程中遇到任何问题可联系：88493092；</p>
          <p>
            2.资讯发布审核通过后将在“业务管理中心”的“资讯管理”中进行管理，发布人可以撤销发布；
          </p>
          <p>
            3.★为照顾大家使用习惯，暂时去掉处级领导审核，各单位自行做好资讯发布线下审核记录；
          </p>
          <p>
            4.门户资讯发布人由各单位自行授权，可由各单位处级领导和办公室主任在“业务管理中心”中的“岗位人员”里对“资讯发布组岗位”进行人员增删。
          </p>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="queButton">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import {
    findAllContent,
    getColumnList,
    workConList,
    caogaoContent,
    getColumnSelectList,
    cancelPublishNews as requestCancelPublishNews,
    getCanMananger,
    changeTop,
    deleteContent,
  } from '@/api/BusinessManagement'
  import store from '@/store'
  import configR from '@/configs.js'
  export default {
    name: 'ApplicationService',
    inheritAttrs: false,
    data() {
      return {
        dialogFormVisible: false,
        showIndex:
          configR.envConfigs.SCHOOL_CODE === 'xigongda'
            ? true
            : false,
        date_start: '',
        date_end: '',
        keyword: '',
        pageNo: 1,
        pageSize: 10,
        status: '',
        loading: true,
        loading1: false,
        terminalOptions: [
          {
            label: '已通过',
            key: '1',
            value: '1',
          },
          {
            label: '不通过',
            key: '2',
            value: '2',
          },
          {
            label: '审核中',
            key: '0',
            value: '0',
          },
        ],
        token: '',
        tableData: [],
        tableData1: [],
        total1: 0,
        total: 0,
        pageNo1: 1,
        form: {
          columnValue: '',
          mobel: '',
        },
        rules: {
          columnName: [
            { required: true, message: '请选择栏目', trigger: 'blur' },
          ],
        },
        columnData: [],
        workConListSelectData: [],
        columnAdminData: [],
        showCaogao: true,
      }
    },
    created() {
      this.token = `${store.state.user.token}`
      // this.workConListData();
      this.getColumnSelectList()
      this.getCanManangerData()
    },
    mounted() {
      window.addEventListener('focus', this.focusData)
      this.$nextTick(() => {
        this.heightConent = document.getElementById('business-center-container')
          ? document.getElementById('business-center-container').offsetHeight -
          200
          : 690
        this.pageSize = parseInt(this.heightConent / 69)
        this.getDataList()
      })
    },
    destroyed() {
      window.removeEventListener('focus')
    },
    methods: {
      onOperCaogao(flag) {
        this.showCaogao = flag
        if (!this.showCaogao) {
          //   this.loading1=true
          this.getCaogaoData()
        } else {
          this.loading = true
          this.getDataList()
        }
      },
      onReviewStatus(row) {
        let columnId = row.columnId
        let yyid
        this.columnData.filter((item) => {
          if (item.id == columnId) {
            yyid = item.flowId
          }
        })
        let link = `${
          configR.envConfigs.FORMFLOW_DESIGN_API_URL
        }write?yyid=${yyid}&columnId=${row.columnId}&columnName=${
          row.columnName
        }&contentId=${row.id}&oneConent=1&token=${this.token}`
        window.open(link)
      },
      async getCaogaoData() {
        let data = {
          pageNo: this.pageNo1,
          pageSize: this.pageSize,
        }
        try {
          let res = await caogaoContent(data)
          if (res.code == 0) {
            if (res.code == 0 && res.data) {
              this.loading1 = false
              this.tableData1 = res.data.items
              this.total1 = res.data.count
              this.tableData1.forEach((item) => {
                item.releaseStartTime =
                  (item.releaseStartTime &&
                    item.releaseStartTime.substring(0, 16)) ||
                  ''
                item.createTime =
                  (item.createTime && item.createTime.substring(0, 16)) || ''
              })
              console.log(this.tableData)
            } else {
              this.tableData1 = []
              this.total1 = 0
              this.loading1 = false
            }
          } else {
            this.tableData1 = []
            this.total1 = 0
            this.loading1 = false
            this.$message({
              message: res.message,
              type: 'error',
            })
          }
        } catch (error) {
          this.tableData1 = []
          this.loading1 = false
          this.total1 = 0
          // this.$message({
          //   message: '接口报错',
          //   type: 'error',
          // })
        }
      },
      //草稿查看
      onOperateCaogao(row) {
        console.log('row', row)
        let columnId = row.columnId
        let yyid
        this.columnData.filter((item) => {
          if (item.id == columnId) {
            yyid = item.flowId
          }
        })
        let link = `${
          configR.envConfigs.FORMFLOW_DESIGN_API_URL
        }write?yyid=${yyid}&columnId=${row.columnId}&columnName=${
          row.columnName
        }&contentId=${row.id}&token=${this.token}`
        window.open(link)
      },
      //草稿删除
      onDeleteCaogao(id) {
        this.$confirm(`此操作将删除, 是否继续?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          let data = {
            id: id,
          }
          deleteContent(data)
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('操作成功')
                this.getCaogaoData()
              } else {
                this.$message.error(res.message)
              }
            })
            .catch(() => {
              this.$message({
                type: 'error',
                message: '操作失败',
              })
            })
        })
      },
      getCanManangerData() {
        getCanMananger().then((res) => {
          if (res.code == 0) {
            console.log('res', res)
            this.columnAdminData = res.data
          } else {
            this.$message.error(res.message)
          }
        })
      },
      changeTopData(id, flag) {
        this.$confirm(
          `此操作将"${flag ? '置顶' : '取消置顶'}", 是否继续?`,
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
        ).then(() => {
          let data = {
            id: id,
            flag: flag,
          }
          changeTop(data)
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('操作成功')
                this.getDataList()
              } else {
                this.$message.error(res.message)
              }
            })
            .catch(() => {
              this.$message({
                type: 'error',
                message: '操作失败',
              })
            })
        })
      },
      getColumnSelectList() {
        getColumnSelectList().then((res) => {
          if (res.code == 0) {
            this.columnData = res.data
          } else {
            this.$message.error(res.message)
          }
        })
      },
      queButton() {
        console.log('表单数据', this.form)
        let arr = this.form.columnValue.split('&')
        let data = {
          columnId: arr[0],
          yyid: arr[1],
          columnName: arr[2],
        }

        let link = `${
          configR.envConfigs.FORMFLOW_DESIGN_API_URL
        }write?yyid=${data.yyid}&columnId=${data.columnId}&columnName=${
          data.columnName
        }&token=${this.token}`
        window.open(link)
        this.dialogFormVisible = false
      },
      focusData() {
        this.loading = true
        this.getDataList()
        this.getCaogaoData()
      },
      asyncData() {
        if (this.showCaogao) {
          this.getDataList()
        } else {
          this.getCaogaoData()
        }
      },
      //获取表格首页
      async getDataList() {
        if (!this.showCaogao) {
          return false
        }
        let data = {
          endTime: this.date_end || '',
          keyWord: this.keyword || '',
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          startTime: this.date_start || '',
          status: this.status,
        }
        try {
          let res = await findAllContent(data)
          if (res.code == 0) {
            if (res.code == 0 && res.data) {
              this.loading = false
              this.tableData = res.data.items
              this.total = res.data.count
              this.tableData.forEach((item) => {
                item.releaseStartTime =
                  (item.releaseStartTime &&
                    item.releaseStartTime.substring(0, 16)) ||
                  ''
                item.createTime =
                  (item.createTime && item.createTime.substring(0, 16)) || ''
              })
              console.log(this.tableData)
            } else {
              this.tableData = []
              this.total = 0
              this.loading = false
            }
          } else {
            this.tableData = []
            this.total = 0
            this.loading = false
            this.$message({
              message: res.message,
              type: 'error',
            })
          }
        } catch (error) {
          this.tableData = []
          this.total = 0
          this.loading = false
          // this.$message({
          //   message: '接口报错',
          //   type: 'error',
          // })
        }
      },
      handle_date(val) {
        this.getDataList()
      },

      //获取流程
      workConListData() {
        workConList().then((res) => {
          console.log('workConList', res.data)
          this.workConListSelectData = res.data.data
        })
      },

      /**
       * 操作
       * @param row
       * @param action
       */
      onOperate() {
        this.dialogFormVisible = true
      },
      //查看
      onOperate1(id, ffid) {
        let link = `${
          configR.envConfigs.FORMFLOW_DESIGN_API_URL
        }looking?ffid=${ffid}&processInstanceId=${id}&token=${this.token}`
        window.open(link)
      },
      onOperate2(id) {
        let routerJump = this.$router.resolve({
          path: '/newsDetail',
          query: {
            id: id,
            from: 'cmsManage',
          },
        })
        window.open(routerJump.href, '_blank')
      },
      cancelPublishNews(row) {
        this.$confirm(`此操作将撤销发布"${row.title}", 是否继续?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          requestCancelPublishNews(row.id)
            .then(() => {
              this.$message({
                type: 'success',
                message: '撤销发布成功!',
              })
              this.loading = true
              this.getDataList()
            })
            .catch(() => {
              this.$message({
                type: 'error',
                message: '撤销发布失败!',
              })
            })
        })
      },
    },
  }
</script>
<style lang="scss" scoped>
  .as-wrapper {
    padding: 28px 20px;
    background-color: white;
  }
  /deep/.el-table th > .cell,
  /deep/.el-table td > .cell {
    display: flex;
    align-items: center;
  }
  button.el-button.el-button--default.is-round,
  button.el-button.el-button--primary.is-round {
    padding: 5px 15px !important;
  }
  .el-button--small.is-round {
    padding: 5px 15px !important;
  }
</style>
